import React, { useState, useEffect } from 'react';
import "./ImageGallery.css";

export default function ImageGallery({ images }) {
    const [selectedImage, setSelectedImage] = useState(images[0]);

    useEffect(() => {
        if (images.length > 0) {
            images[1] ? setSelectedImage(images[1]) : setSelectedImage(images[0])
        }
    }, [images]);

    return (
        <div className='galleryContainer'>
            <img className="mainImage" src={selectedImage} alt=''/>
            <div className='imageScroller'>
                {images.map((img, index) => (
                    <img 
                        key={index} 
                        src={img} 
                        alt={`Thumbnail ${index}`}
                        onClick={() => setSelectedImage(img)} 
                        className="thumbnail"
                    />
                ))}
            </div>
        </div>
    );
}
